import _extends from "@babel/runtime/helpers/extends";
import { mapGeocodeToAddress } from "./address"; //   import { track } from "../units/tracking";

var _autocompleteService;

var _placesService;

var _geocoder;

var _token;

var _tokenTime = 0; // https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service

var autocompleteService = function autocompleteService() {
  _autocompleteService = _autocompleteService || new window.google.maps.places.AutocompleteService();
  return _autocompleteService;
}; // https://developers.google.com/maps/documentation/javascript/reference/places-service


var placesService = function placesService() {
  _placesService = _placesService || new window.google.maps.places.PlacesService(document.createElement("div"));
  return _placesService;
}; // https://developers.google.com/maps/documentation/javascript/reference/geocoder


var geocoder = function geocoder() {
  _geocoder = _geocoder || new window.google.maps.Geocoder();
  return _geocoder;
};

var token = function token() {
  var now = Date.now(); // Use the current token if it is within 3 minutes
  // https://stackoverflow.com/questions/50398801/how-long-do-the-new-places-api-session-tokens-last

  if (_token && _tokenTime + 180000 > now) {
    return _token;
  }

  _tokenTime = now;
  _token = new window.google.maps.places.AutocompleteSessionToken();
  return _token;
};

var clearToken = function clearToken() {
  _token = undefined;
};

var buildCallback = function buildCallback(resolve, fallback) {
  return function (result, status) {
    var STATUSES = window.google.maps.places.PlacesServiceStatus;

    if (status === STATUSES.OK) {
      resolve(result);
      return;
    }

    if (status === STATUSES.OVER_QUERY_LIMIT) {
      throw new Error("Google Map API is over the query limit");
    }

    if (status === STATUSES.REQUEST_DENIED) {
      throw new Error("Google Maps API request was denied");
    }

    resolve(fallback);
  };
};

export var getPlacePredictions = function getPlacePredictions(options) {
  return new Promise(function (resolve) {
    autocompleteService().getPlacePredictions(_extends({
      componentRestrictions: {
        country: "US"
      },
      types: ["geocode"],
      sessionToken: token()
    }, options), buildCallback(resolve, []));
  });
};
export var getPlaceDetails = function getPlaceDetails(_ref) {
  var placeId = _ref.placeId,
      _ref$isEstablishment = _ref.isEstablishment,
      isEstablishment = _ref$isEstablishment === void 0 ? false : _ref$isEstablishment;
  return new Promise(function (resolve) {
    placesService().getDetails({
      fields: isEstablishment ? ["address_components", "formatted_address", "geometry", "types", "name"] : ["address_components", "formatted_address", "geometry", "types"],
      placeId: placeId,
      sessionToken: token()
    }, buildCallback(function (data) {
      clearToken();
      resolve(mapGeocodeToAddress(data, placeId));
    }, null));
  });
};
export var findAddress = function findAddress(_ref2) {
  var address = _ref2.address;
  return new Promise(function (resolve) {
    geocoder().geocode({
      componentRestrictions: {
        country: "US"
      },
      address: address
    }, buildCallback(function (data) {
      resolve(data.map(mapGeocodeToAddress));
    }, []));
  });
};
export var findCoordinates = function findCoordinates(location) {
  return new Promise(function (resolve) {
    geocoder().geocode({
      location: location
    }, buildCallback(function (data) {
      resolve(data[0] ? mapGeocodeToAddress(data[0]) : null);
    }, []));
  });
};
export var getGeocoderPlace = function getGeocoderPlace(_ref3) {
  var placeId = _ref3.placeId;
  return new Promise(function (resolve) {
    geocoder().geocode({
      placeId: placeId
    }, buildCallback(function (data) {
      resolve(data[0] ? mapGeocodeToAddress(data[0]) : null);
    }, null));
  });
};
export var getPlace = function getPlace(options) {
  return Promise.all([getPlaceDetails(options), getGeocoderPlace(options)]).then(function (_ref4) {
    var address = _ref4[0],
        geocoderAddress = _ref4[1];

    if (!geocoderAddress) {
      return address;
    }

    var validation = geocoderAddress.validation,
        locationType = geocoderAddress.locationType,
        lat = geocoderAddress.lat,
        lng = geocoderAddress.lng,
        placeId = geocoderAddress.placeId;
    return _extends({}, address, {
      validation: validation,
      locationType: locationType,
      lat: lat,
      lng: lng,
      placeId: placeId
    });
  });
};